import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";

declare const $: any;
declare var swal: any;


interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    selector: 'cmp-conf-documentos',
    templateUrl: './view/cmp-conf-documentos.component.html',
    styleUrls: ['./css/cmp-conf-documentos.component.scss']
})
export class CmpConfDocumentosComponent implements OnInit, OnChanges {

    TEMPLATE_EMAIL_DEFAULT = 'DEFAULT';
    TEMPLATE_EMAIL_DINAMIC = 'DINAMIC';

    @Input() pdfDocumentTemplates;
    @Input() emisor;
    urlBack;

    constructor(private util: UtilConfig) {
    }

    /**
     * Set color from color picker
     * @param {string} type
     * @param {string} color
     */
    public setColor(type: string, color: string) {
        switch (type) {
            case 'MensajeInicial':
                this.emisor.emailStartMessageColor = color;
                break;
            case 'hola':
                this.emisor.emailHiColor = color;
                break;
            default:
                break;
        }
    }

    ngOnInit() {
        if (!this.emisor.emailStartMessageColor) {
            this.emisor.emailStartMessageColor = '#000000';
        }
        if (!this.emisor.emailHiColor) {
            this.emisor.emailHiColor = '#000000';
        }
        this.urlBack = this.util.URL_WS_BACKEND;

        this.pdfDocumentTemplates.forEach((item) => {
            if (item.id === this.emisor.pdfDocumentTemplate.id) {
                this.emisor.pdfDocumentTemplate = item;
            }
        });
    }

    cambiarBanner($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: FileReaderEvent) => {
                this.emisor.banner = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    cambiarLogo($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: FileReaderEvent) => {
                this.emisor.emailLogo = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    removeBanner() {
        this.emisor.banner = null;
    }

    removeLogo() {
        this.emisor.emailLogo = null;
    }

    habilitarRemitente() {
        this.emisor.emailMasked = !this.emisor.emailMasked;
    }

    habilitarEnableSendMailCDR() {
        this.emisor.enableSendMailCDR = !this.emisor.enableSendMailCDR;
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-documentos/cmp-conf-documentos.component.ts